import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  sidebar: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    padding: '10px 0px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    transition: 'width .25s ease-in-out 0s',
    justifyContent: 'center',
    position: 'relative',
    zIndex: '8',
    maxWidth: '75px',
    width: '10%',
  },
  menu: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    padding: '0px 10px',
    boxSizing: 'border-box',
  },
  listItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      cursor: 'pointer',
      width: '32px',
      height: '32px',
    },
  },
  listItemText: {
    transition: 'color 1s cubic-bezier(0.4, 0, 0.6, 1) 0ms',
    overflow: 'hidden',
    color: 'transparent',
    position: 'unset',
    maxHeight: 'unset',
  },
  burger: {
    position: 'absolute',
    right: '-10px',
    top: '80px',
    background: '#00142d',
    padding: '10px',
    borderRadius: '50%',
    cursor: 'pointer',
    '&:hover': {
      background: '#747474',
      color: 'white',
    },
  },
  themeSwitch: {
    position: 'relative',
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.mode === 'light' && theme.palette.primary.main,
      backgroundImage:
        theme.palette.mode === 'dark'
          ? 'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path  fill="yellow" d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Z" /></svg>\')'
          : 'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path  fill="yellow" d="M480-280q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Z"/></svg>\')',
    },
    '& .MuiSwitch-track': {
      background: 'white',
    },
  },
  sunIcon: {
    position: 'absolute',
    zIndex: 2,
    width: '15px',
    left: '11px',
    top: '3px',
  },
  moonIcon: {
    position: 'absolute',
    zIndex: 2,
    width: '15px',
    right: '11px',
    top: '3px',
  },
  activeItem: {
    '& path': {
      fill: '#000',
    },
    '&::after': {
      position: 'absolute',
      borderRadius: '4px',
      content: '""',
      background: '#fff',
      display: 'block',
      height: '50px',
      width: '85%',
      zIndex: '-1',
    },
  },
  homeItem: { marginBottom: 'auto', flexDirection: 'column' },
  activeHoneItem: {
    '&::after': {
      height: '40px',
      top: '7px',
    },
  },
}));

export default useStyles;
